import { Component, OnInit } from '@angular/core';
import {
  Router,
  Params,
  ActivatedRoute,
  NavigationExtras,
} from '@angular/router';
import { Location } from '@angular/common';

import { Helper } from '../../helper';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  logo = 'assets/images/FysioDK.jpg';
  logo_mobile = 'assets/images/small-logo.svg';
  is_logged_in = false;
  fisiqClinics = false;
  mobNav = false;
  token: string;
  profileLink: string;
  flowType: string;
  superClinicId: string;
  preselectedClinic: string;
  service: string;
  singleClinic: string;
  clinicName: string;
  currentUser: any = this.helper.getStorage('currentUser');

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    public helper: Helper
  ) {
    router.events.subscribe((val) => {
      const all_clinics: Array<any> = this.helper.getStorage('allClinics');
      const current_user: any = this.helper.getStorage('currentUser');

      if (
        current_user &&
        current_user.data.email &&
        current_user.data.email !== undefined &&
        current_user.data.CPRNumber &&
        current_user.data.CPRNumber !== undefined
      ) {
        this.is_logged_in = true;
      } else {
        this.is_logged_in = false;
      }
     
      if (current_user) {
        // custom logos and name
        if (all_clinics && router.url.includes('clinics')) {
          const regular_id = router.url.replace(
            /.*clinics=([^&]*).*|(.*)/,
            '$1'
          );
          const regular_clinic = all_clinics.find(
            (clinic) => clinic.id === regular_id
          );

          this.clinicName = regular_clinic.name;

          if (regular_clinic.picture) {
            this.logo = regular_clinic.picture;
            this.logo_mobile = regular_clinic.picture;
          } else {
            this.logo = 'assets/images/FysioDK.jpg';
            this.logo_mobile = 'assets/images/small-logo.svg';
          }
        } else {
          this.clinicName = null;

          this.logo = 'assets/images/FysioDK.jpg';
          this.logo_mobile = 'assets/images/small-logo.svg';
        }

        if (
          router.url.includes('singleClinic=true') ||
          router.url.includes('superClinicId')
        ) {
          if (router.url.includes('singleClinic=true')) {
            const clinic_id = router.url.replace(
              /.*clinics=([^&]*).*|(.*)/,
              '$1'
            );
            const clinic = all_clinics.find(
              (clinic) => clinic.id === clinic_id
            );

            if (clinic.picture) {
              this.logo = clinic.picture;
              this.logo_mobile = clinic.picture;
            } else {
              this.logo = 'assets/images/FysioDK.jpg';
              this.logo_mobile = 'assets/images/small-logo.svg';
            }
          }

          if (router.url.includes('superClinicId')) {
            const super_id = router.url.replace(
              /.*superClinicId=([^&]*).*|(.*)/,
              '$1'
            );
            const super_clinic = all_clinics.find(
              (clinic) => clinic.id === super_id
            );

            if (router.url.includes('clinics')) {
              const clinic_id = router.url.replace(
                /.*clinics=([^&]*).*|(.*)/,
                '$1'
              );
              const clinic = all_clinics.find(
                (clinic) => clinic.id === clinic_id
              );

              if (clinic.picture) {
                this.logo = clinic.picture;
                this.logo_mobile = clinic.picture;
              } else {
                if (super_clinic.picture) {
                  this.logo = super_clinic.picture;
                  this.logo_mobile = super_clinic.picture;
                } else {
                  this.logo = 'assets/images/FysioDK.jpg';
                  this.logo_mobile = 'assets/images/small-logo.svg';
                }
              }
            } else {
              if (super_clinic.picture) {
                this.logo = super_clinic.picture;
                this.logo_mobile = super_clinic.picture;
              } else {
                this.logo = 'assets/images/FysioDK.jpg';
                this.logo_mobile = 'assets/images/small-logo.svg';
              }
            }
          }
        }
      } else {
        this.logo = 'assets/images/FysioDK.jpg';
        this.logo_mobile = 'assets/images/small-logo.svg';
        this.clinicName = null;
      }
    });
  }

  ngOnInit() {
    const currentPath = window.location.pathname;

    if (currentPath.includes('/login') || currentPath === '/') {
      localStorage.clear();
    }
    
    const current_user: any = this.helper.getStorage('currentUser');

    if (
      current_user &&
      current_user.data.email &&
      current_user.data.email !== undefined &&
      current_user.data.CPRNumber &&
      current_user.data.CPRNumber !== undefined
    ) {
      this.is_logged_in = true;
    } else {
      this.is_logged_in = false;
    }

    this.route.queryParams.subscribe((params: Params) => {
      this.flowType = params.type;
      this.preselectedClinic = params.clinics;
      this.superClinicId = params.superClinicId;
      this.service = params.service;
      this.singleClinic = params.singleClinic;

      if (params.bookingToken) {
        this.token = params.bookingToken;
        this.profileLink = '/profile?token=' + this.token;
      } else {
        this.profileLink = '/profile';
      }
    });
  }

  toggleMobNav() {
    this.mobNav = !this.mobNav;
  }

  setupUrl(url) {
    const params = {
      type: this.flowType,
      service: this.service,
      singleClinic: this.singleClinic,
    };

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    // if singleclinic flow, send clinics params to next page
    if (this.singleClinic === 'true') {
      params['clinics'] = this.preselectedClinic;
    }

    // if fysiq flow, don't send service
    if (url === '/offer-fysiq') {
      params['service'] = null;
    }

    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };

    this.router.navigate([url], navigationExtras);
  }

  goToService() {
    // if superclinic / superclinic + service / single clinic flow, go to find clinic
     if (this.superClinicId) {
      this.setupUrl('/find-clinic');
    } else {
      this.setupUrl('/offer-fysiq');
    }
  }

  logout() {
    localStorage.clear();

    this.is_logged_in = false;
    this.setupUrl('/login');
  }

  toProfile() {
    this.mobNav = false;
    this.setupUrl(this.profileLink);
  }

  myBookings() {
    this.mobNav = false;
    this.setupUrl('/bookings');
  }

  bookNew() {
    this.mobNav = false;
    // if superclinic / superclinic + service / single clinic flow, go to find clinic
    // if (this.superClinicId) {
      this.setupUrl('/find-clinic');
    // } else {
    //   this.setupUrl('/offer-fysiq');
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts